@if (groupHistoryItems?.length > 0) {
  <ul>
    @for (groupHistoryItem of groupHistoryItems; track groupHistoryItem) {
      <div>
        @if (groupHistoryItem.changesGrouped?.length > 0) {
          <li class="item-history">
            {{ groupHistoryItem.date | date:'medium' }}
            @if (groupHistoryItem.user) {
              <span>{{ groupHistoryItem.titleDisplayed }}</span>
            }
            <span class="details-button" [nbPopover]="templateRef" nbPopoverPlacement="right">
              <fa-icon icon="comment-alt-lines"></fa-icon>
            </span>
          </li>
        }
        <ng-template #templateRef>
          <ul class="list-history">
            @for (changeGrouped of groupHistoryItem.changesGrouped; track changeGrouped) {
              @if (changeGrouped.changes?.length > 0) {
                @if (changeGrouped.object_type && changeGrouped.object_id) {
                  <li>{{ changeGrouped.object_type | translate }} - {{ changeGrouped.object_id }}:</li>
                  <ul>
                    <app-history-changes-list [changes]="changeGrouped.changes"></app-history-changes-list>
                  </ul>
                }
                @if (!changeGrouped.object_type && !changeGrouped.object_id) {
                  <app-history-changes-list [changes]="changeGrouped.changes"></app-history-changes-list>
                }
              }
            }
          </ul>
        </ng-template>
      </div>
    }
  </ul>
}
